export const DEFAULT_OPTION_DATA_CACHE_TIME = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

export const WEBSOCKET_CONFIG = {
  RECONNECT_INTERVAL: 5000,
  MAX_RECONNECT_ATTEMPTS: 5,
};

export const SENTRY_CONFIG = {
  ERROR_MESSAGE_LENGTH: 1000,
};
